import { render, staticRenderFns } from "./CRUDTableCommonKPI.vue?vue&type=template&id=dd10fa0e&scoped=true"
import script from "./CRUDTableCommonKPI.vue?vue&type=script&lang=js"
export * from "./CRUDTableCommonKPI.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableCommonKPI.vue?vue&type=style&index=0&id=dd10fa0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd10fa0e",
  null
  
)

export default component.exports